import { z } from 'zod/v4';
import type { FeatureFlagAdapter } from '../types.js';

const FlagSnapshotSchema = z.record(z.string(), z.union([z.boolean(), z.string()]));

export function createStaticAdapter(flags?: unknown): FeatureFlagAdapter {
  const parsedFlags = FlagSnapshotSchema.parse(flags ?? {});

  return {
    getFlags() {
      return parsedFlags;
    },
  };
}
